import { Component, Vue, Watch } from "vue-property-decorator";
import http from "../services/Http";
import { TotalValueOfGoodsModel } from "../models/cart";
import { deliveriesStore } from "@/store/DeliveriesModule";
import { DeliveryModel, DeliveryMethodModel, CheckoutTranslationModel as TranslationModel } from "../models/deliveryModel";
import { EventBus } from "../events";


@Component
export default class CartSummaryTotalValueOfGoods extends Vue {
    protected translations: TranslationModel;
    protected vm: any = {};
    private url: string = window.location.origin + window.location.pathname;
    private deliveries: DeliveryModel[] = new Array<DeliveryModel>();

    constructor() {
        super();
        this.translations = window.__finja.translations as TranslationModel;
    }

    protected created() {
         this.getCartSummary();
    }

    protected mounted() {
        EventBus.$on("refreshCartSummary", (variantId: string) => {
            if (deliveriesStore.deliveries.postalCode !== undefined) {
                this.getDeliveriesRefreshed();
            } else {
                this.getCartSummary();
                this.getHandlingFeeMessage();
            }
        });
    }

    private getCartSummary() {
        http.get<TotalValueOfGoodsModel>(`${this.url}.GetTotalValueOfGoodsSectionData`)
            .then(r => {
                deliveriesStore.dispatchTotalValueOfGoods(r);
            });
    }
    private getHandlingFeeMessage() {
        http.get<DeliveryModel>(`${this.url}.GetHandlingFeeMessageOnLoad`)
            .then(r => {
                deliveriesStore.dispatchDeliveries(r);
            });
        }

    private getDeliveriesRefreshed() {
        http.get<DeliveryMethodModel>(`${this.url}.GetDeliveryMethods?postalCode=${deliveriesStore.deliveries.postalCode}`)
                .then(r => {
                    this.deliveries = r.deliveryMethods;

                    if (this.deliveries.length === 1) {
                        deliveriesStore.dispatchDeliveries(this.deliveries[0]);
                        deliveriesStore.dispatchTotalValueOfGoods(this.deliveries[0].totalValueOfGoods);
                    }
                });

    }


    get deliveryCost(): string {
        return deliveriesStore.totalValueOfGoods && deliveriesStore.totalValueOfGoods.deliveryCost;
    }

    get deliveryCostDiscount(): string {
        return deliveriesStore.totalValueOfGoods && deliveriesStore.totalValueOfGoods.deliveryCostDiscount;
    }

    get discount(): string {
        return deliveriesStore.totalValueOfGoods && deliveriesStore.totalValueOfGoods.discount;
    }

    get total(): string {
        return deliveriesStore.totalValueOfGoods && deliveriesStore.totalValueOfGoods.total;
    }

    get isCompanyUser(): boolean {
        return deliveriesStore.totalValueOfGoods && deliveriesStore.totalValueOfGoods.isCompanyUser;
    }

    get mva(): string {
        return deliveriesStore.totalValueOfGoods && deliveriesStore.totalValueOfGoods.mva;
    }

    get handlingFee(): string {
        return deliveriesStore.totalValueOfGoods && deliveriesStore.totalValueOfGoods.handlingFee;
    }

    get totalProduct(): string {
        return deliveriesStore.totalValueOfGoods && deliveriesStore.totalValueOfGoods.totalProduct;
    }

    get weight(): string {
        return deliveriesStore.totalValueOfGoods && deliveriesStore.totalValueOfGoods.weight;
    }

    get isResellerCheckout(): boolean {
        return deliveriesStore.totalValueOfGoods && deliveriesStore.totalValueOfGoods.allowBuyingGDSProducts;
    }
    get palletQuantity(): string {
        return deliveriesStore.totalValueOfGoods && deliveriesStore.totalValueOfGoods.palletQuantity;
    }
    get palletFee(): string {
        return deliveriesStore.totalValueOfGoods && deliveriesStore.totalValueOfGoods.palletFee;
    }
}
